import styled from "@emotion/styled";
import { SpeakingSessionExaminerAvailabilityDto } from "api/planning";
import { DateTime } from "luxon";
import { Divider, Icon } from "semantic-ui-react";

export type Props = {
  availabilities?: SpeakingSessionExaminerAvailabilityDto[];
  unavailabilities?: SpeakingSessionExaminerAvailabilityDto[];
}

export const formatExaminerAvailabilityTime = (datetime: string) => {
  return DateTime.fromISO(datetime, { setZone: true }).toFormat('HH:mm');
};

export const ExaminerAvailabilityDisplay = ({ availabilities, unavailabilities }: Props) => {
  const anyAvailabilityDeclared = (!!availabilities?.length || !!unavailabilities?.length);

  if (!anyAvailabilityDeclared) {
    return null;
  }

  return (
    <>
      <Divider />
      <S.AvailabilityHeader>Declared availability: </S.AvailabilityHeader>

      {availabilities && availabilities.length > 0 && (
        <S.AvailabilityList>
          {availabilities.map(av => (
            <S.AvailabilityItem key={`available-${av.startDateTime}-${av.endDateTime}`}>
              <Icon name="checkmark" color="green" />
              {formatExaminerAvailabilityTime(av.startDateTime)} - {formatExaminerAvailabilityTime(av.endDateTime)}
            </S.AvailabilityItem>
          ))}
        </S.AvailabilityList>
      )}

      {unavailabilities && unavailabilities.length > 0 && (
        <S.AvailabilityList>
          {unavailabilities.map(uav => (
            <S.AvailabilityItem key={`unavailable-${uav.startDateTime}-${uav.endDateTime}`}>
              <Icon name="close" color="red" />
              {formatExaminerAvailabilityTime(uav.startDateTime)} - {formatExaminerAvailabilityTime(uav.endDateTime)}
            </S.AvailabilityItem>
          ))}
        </S.AvailabilityList>
      )}
    </>
  )
};

const S = {
  Header: styled.div`
        font-weight: bold;
        margin-bottom: 0.5em;
  `,
  HeaderDescription: styled.div`
        font-size: 0.9em;
        color: #666;
    `,
  AvailabilityHeader: styled.div`
        font-weight: bold;
        font-size: 0.9em;
        margin-top: 0.5em;
    `,
  AvailabilityList: styled.div`
        display: flex;
        flex-direction: column;
        gap: 0.25em;
    `,
  AvailabilityItem: styled.div`
        display: flex;
        align-items: center;
        gap: 0.5em;
        font-size: 0.85em;
    `
};